/* SEERAT v5.4.0 — Facticied */
/* Seerat - browsing nudge

   Cycles a small card in a bottom corner. Every card is true when it shows:
   the recently viewed one is read from this visitor's own browser, the low
   stock one was only rendered because the real count was low, and the rest
   are what the merchant typed. Nothing here invents a buyer. */

(function () {
  'use strict';

  var STORE = 'seerat:viewed';
  var MAX = 8;

  /* localStorage is unavailable in some private windows and throws rather
     than returning null, so every touch of it is wrapped. */
  function read() {
    try {
      return JSON.parse(window.localStorage.getItem(STORE) || '[]');
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(STORE, JSON.stringify(list.slice(0, MAX)));
    } catch (e) {
      /* full, blocked, or private: the nudge simply skips this card */
    }
  }

  // Called from the product page so the card has something honest to show.
  function remember(item) {
    if (!item || !item.url) return;
    var list = read().filter(function (x) { return x && x.url !== item.url; });
    list.unshift(item);
    write(list);
  }

  function Nudge(root) {
    this.root = root;
    this.cards = Array.prototype.slice.call(root.querySelectorAll('[data-nudge-card]'));
    this.close = root.querySelector('[data-nudge-close]');
    this.index = -1;
    this.timer = null;
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!this.onThisPage()) return;
    this.fillRecent();
    this.cards = this.cards.filter(function (c) { return c.dataset.ready === 'true' || c.dataset.nudgeCard !== 'recent'; });
    if (this.cards.length === 0) return;
    if (this.dismissed()) return;

    this.bind();
    var self = this;
    this.timer = setTimeout(function () { self.next(); },
      (parseFloat(root.dataset.firstDelay) || 0) * 1000);
  }

  Nudge.prototype.onThisPage = function () {
    var want = this.root.dataset.pages || 'all';
    if (want === 'all') return true;
    var path = window.location.pathname;
    if (want === 'products') return path.indexOf('/products/') !== -1;
    if (want === 'collections') {
      return path.indexOf('/products/') !== -1 || path.indexOf('/collections') !== -1;
    }
    return true;
  };

  Nudge.prototype.dismissed = function () {
    if (this.root.dataset.remember !== 'true') return false;
    try {
      return window.sessionStorage.getItem('seerat:nudge-off') === '1';
    } catch (e) {
      return false;
    }
  };

  /* The recently viewed card is a shell until there is something to put in
     it. With nothing stored it is dropped rather than shown empty. */
  Nudge.prototype.fillRecent = function () {
    var card = this.root.querySelector('[data-nudge-card="recent"]');
    if (!card) return;
    var here = window.location.pathname;
    var item = read().filter(function (x) { return x.url && x.url !== here; })[0];
    if (!item) return;

    var link = card.querySelector('[data-nudge-href]');
    var img = card.querySelector('[data-nudge-img]');
    var title = card.querySelector('[data-nudge-title]');
    var meta = card.querySelector('[data-nudge-meta]');
    if (link) link.setAttribute('href', item.url);
    if (img && item.image) {
      img.setAttribute('src', item.image);
      img.setAttribute('alt', '');
    } else if (img) {
      img.remove();
    }
    if (title) title.textContent = item.title || '';
    if (meta) meta.textContent = item.price || '';
    card.dataset.ready = 'true';
  };

  Nudge.prototype.show = function (i) {
    this.cards.forEach(function (c) {
      c.hidden = true;
      c.classList.remove('is-in');
    });
    var card = this.cards[i];
    if (!card) return;
    card.hidden = false;
    this.root.hidden = false;
    // next frame, so the transition has a state to move away from
    window.requestAnimationFrame(function () { card.classList.add('is-in'); });
  };

  Nudge.prototype.hide = function () {
    var self = this;
    var card = this.cards[this.index];
    if (card) card.classList.remove('is-in');
    setTimeout(function () {
      if (card) card.hidden = true;
      self.root.hidden = true;
    }, this.reduced ? 0 : 320);
  };

  Nudge.prototype.next = function () {
    var self = this;
    var loop = this.root.dataset.loop === 'true';
    this.index += 1;
    if (this.index >= this.cards.length) {
      if (!loop) { this.root.hidden = true; return; }
      this.index = 0;
    }
    this.show(this.index);

    var stay = (parseFloat(this.root.dataset.visibleFor) || 6) * 1000;
    var gap = (parseFloat(this.root.dataset.interval) || 5) * 1000;
    clearTimeout(this.timer);
    this.timer = setTimeout(function () {
      self.hide();
      clearTimeout(self.timer);
      self.timer = setTimeout(function () { self.next(); }, gap);
    }, stay);
  };

  Nudge.prototype.stop = function (remember) {
    clearTimeout(this.timer);
    this.timer = null;
    this.hide();
    if (remember && this.root.dataset.remember === 'true') {
      try { window.sessionStorage.setItem('seerat:nudge-off', '1'); } catch (e) {}
    }
  };

  Nudge.prototype.bind = function () {
    var self = this;
    if (this.close) {
      this.close.addEventListener('click', function () { self.stop(true); });
    }
    // Reading one should not be a race against the clock.
    this.root.addEventListener('mouseenter', function () { clearTimeout(self.timer); });
    this.root.addEventListener('mouseleave', function () {
      if (self.timer === null) return;
      clearTimeout(self.timer);
      self.timer = setTimeout(function () { self.next(); },
        (parseFloat(self.root.dataset.interval) || 5) * 1000);
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) clearTimeout(self.timer);
    });
  };

  /* Recorded here rather than from the product script, because both files
     are deferred and the product one runs first - it would be calling a
     function this file had not defined yet. Storage lives here, so the
     writing does too. */
  function rememberCurrentProduct() {
    var el = document.querySelector('.seerat-pdp[data-url]');
    if (!el || el.dataset.seeratRemembered === 'true') return;
    el.dataset.seeratRemembered = 'true';
    remember({
      url: el.getAttribute('data-url'),
      title: el.getAttribute('data-seerat-title'),
      image: el.getAttribute('data-seerat-image'),
      price: el.getAttribute('data-seerat-price')
    });
  }

  function init() {
    rememberCurrentProduct();
    Array.prototype.forEach.call(document.querySelectorAll('seerat-nudge'), function (el) {
      if (el.dataset.ready === 'true') return;
      el.dataset.ready = 'true';
      new Nudge(el);
    });
  }

  window.SeeratRememberProduct = remember;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
